module.exports = __webpack_public_path__ + "static/media/srinath.2fe49fdb.jpg";